import React, { useState, useEffect } from 'react';
import { Smile, Loader2, Check } from 'lucide-react';

const MOODS = [
  { key: 'great', emoji: '😄' }, { key: 'good', emoji: '🙂' }, { key: 'okay', emoji: '😐' },
  { key: 'bad', emoji: '😕' }, { key: 'awful', emoji: '😣' },
];

/** Notes + humeur du jour (journal de bord libre, façon Yazio). */
export const MoodWidget = ({ mood, noteText, onSave, en }) => {
  const [selected, setSelected] = useState(mood || null);
  const [text, setText] = useState(noteText || '');
  const [busy, setBusy] = useState(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => { if (!dirty) { setSelected(mood || null); setText(noteText || ''); } }, [mood, noteText, dirty]);

  const save = async () => {
    setBusy(true);
    try { await onSave(selected, text); setDirty(false); }
    finally { setBusy(false); }
  };

  return (
    <div className="rounded-3xl bg-white/[0.035] backdrop-blur-xl border border-white/10 shadow-[0_0_30px_-12px_rgba(217,70,239,0.25)] p-5" data-testid="mood-widget">
      <div className="flex items-center gap-2 mb-3">
        <Smile className="w-5 h-5 text-yellow-400" />
        <h3 className="font-bold text-white">{en ? 'How was your day?' : "Comment s'est passée votre journée ?"}</h3>
      </div>
      <div className="flex items-center justify-between mb-4">
        {MOODS.map((m) => (
          <button
            key={m.key}
            onClick={() => { setSelected(m.key); setDirty(true); }}
            className={`text-3xl transition-all ${selected === m.key ? 'scale-125 grayscale-0' : 'grayscale opacity-60 hover:grayscale-0 hover:opacity-100'}`}
            data-testid={`mood-emoji-${m.key}`}
          >
            {m.emoji}
          </button>
        ))}
      </div>
      <textarea
        value={text} onChange={(e) => { setText(e.target.value); setDirty(true); }} rows={2}
        placeholder={en ? 'Write a quick note about your day…' : 'Notez un mot rapide sur votre journée…'}
        className="w-full bg-zinc-900 border border-white/10 rounded-2xl p-4 text-white text-sm focus:border-primary/50 focus:outline-none resize-none"
        data-testid="mood-notes-input"
      />
      {dirty && (
        <button onClick={save} disabled={busy} className="mt-3 w-full py-2.5 rounded-xl font-bold text-white bg-gradient-to-r from-primary to-pink-500 disabled:opacity-60 flex items-center justify-center gap-2 text-sm" data-testid="mood-save-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />} {en ? 'Save' : 'Enregistrer'}
        </button>
      )}
    </div>
  );
};

export default MoodWidget;
